import { type FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { SidebarBox } from './SidebarBox';
import { CourseCardList } from './CourseCardList';
import { type CourseCard } from '../StreamDashboard.types';
import '../locales/streamDashboard/streamDashboard-en.json';

type Props = {
    courses: CourseCard[];
    streamTitle: string;
    onSelectCourse: (courseId: string) => void;
    className?: string;
};

export const RecommendedCoursesBox: FC<Props> = ({ courses, streamTitle, onSelectCourse, className }) => {
    const { t } = useTranslation('back_royal', { keyPrefix: 'streamDashboard.streamDashboard' });

    if (!courses.length) return null;

    return (
        <SidebarBox caption={t('recommended_study')} className={className}>
            <p>
                {/* The string wraps the course title in <strong>, so it needs a Trans slot rather
                    than interpolation. */}
                <Trans
                    t={t}
                    i18nKey="we_suggest_following_x"
                    values={{ title: streamTitle }}
                    components={{ strong: <strong /> }}
                />
            </p>
            <CourseCardList courses={courses} onSelectCourse={onSelectCourse} />
        </SidebarBox>
    );
};
